import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { ErrorPage, MainLayout } from "@/components";
import { ErrorPageType } from "@/enum";
import { useAppSelector } from "@/redux/hooks";
import { ROUTE_CONFIG } from "@/routes/config";

import { authSelector } from "../Public/redux/auth.slice";
import { Account } from "./pages/Account/Account";
import { Companies } from "./pages/Companies/Companies";
import { Company } from "./pages/Company/Company";
import { ToDo } from "./pages/ToDo/ToDo";
import { Admin } from "./routes/Admin";
import ManageQuestionnaire from "./pages/ManageQuestionnaire/ManageQuestionnaire";
import ManageIndustries from "./pages/ManageIndustries/ManageIndustries";
import ManageCompanySize from "./pages/ManageCompanySize/ManageCompanySize";
import ManageCompanyRevenue from "./pages/ManageCompanyRevenue/ManageCompanyRevenue";
import ManageCompanyBalance from "./pages/ManageCompanyBalance/ManageCompanyBalance";
import ManageTaskTemplates from "./pages/ManageTaskTemplates/ManageTaskTemplates";
import { NotificationSocketProvider } from "./pages/Notifications/providers/NotificationSocketContext";

const { LOGIN, ERROR_PAGE } = ROUTE_CONFIG;

export const Private: FunctionComponent = () => {
	const { user } = useAppSelector(authSelector);

	if (!user) {
		return <Navigate to={LOGIN} />;
	}

	if (!user?.company?.isAccepted) {
		return <Navigate to={ERROR_PAGE} />;
	}

	return (
		<NotificationSocketProvider>
			<Routes>
				<Route element={<MainLayout />}>
					<Route element={<Account />} path="/account" />
					<Route element={<Company />} path="/company" />
					<Route element={<Admin />} path="/users/*" />
					<Route element={<Companies />} path="/companies/*" />
					<Route element={<ToDo />} path="/to-do/*" />
					<Route element={<ManageQuestionnaire />} path="/questionnaire" />
					<Route element={<ManageIndustries />} path="/industries" />
					<Route element={<ManageCompanySize />} path="/company-sizes" />
					<Route element={<ManageCompanyRevenue />} path="/company-revenues" />
					<Route element={<ManageCompanyBalance />} path="/company-balances" />
					<Route element={<ManageTaskTemplates />} path="/task-templates" />
				</Route>
				<Route element={<ErrorPage type={ErrorPageType.NotFound} />} path="*" />
				<Route element={<ErrorPage type={ErrorPageType.Forbidden} />} path="/error-page" />
			</Routes>
		</NotificationSocketProvider>
	);
};
